import React from "react";
// import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import PublicViewContainer from "./PublicViewContainer";

export default () => {
  // const { isProtected, checkRoles } = {
  //   ...AppRoutingRoles[AppRouteURI.PUBLIC],
  // };
  return (
    <App>
      <PublicViewContainer />
    </App>
  );
};
